module.exports = __webpack_public_path__ + "static/media/feature-space-analytics.03c098eb.png";